import React from "react";

const LinkBoldNeueIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.75 11.25L16 9.99996C17.6569 8.34306 17.6569 5.65681 16 3.99996C14.3431 2.34311 11.6569 2.34311 10 3.99996L8.75 5.24996",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.24999 8.75L3.99999 10C2.34314 11.6569 2.34314 14.3431 3.99999 16C5.65684 17.6569 8.34309 17.6569 9.99999 16L11.25 14.75",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 7.75L7.75 12.25",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LinkBoldNeueIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;